<template>
    <form class="office-form form-horizontal" @submit.prevent="handleSubmit">
        <div class="form-group" :class="{ 'has-error': errors['name'] }">
            <label for="name" class="col-sm-2 control-label">Título</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="name" v-model="data.name">
                <div class="help-block" v-for="e in errors['name']">{{ e }}</div>
            </div>
        </div>
        <!-- Componente de Ubicación -->
        <location-section v-model="locationData" :errors="errors" ref="locationSection"></location-section>

        <div class="form-group" :class="{ 'has-error': errors['status'] }">
            <label class="col-sm-2 control-label">¿Operativa?</label>
            <div class="col-sm-10">
                <el-switch v-model="data.status" on-text="Si" off-text="No" :on-value="1" :off-value="0">
                </el-switch>
                <div class="help-block" v-for="e in errors['status']">{{ e }}</div>
            </div>
        </div>

        <div v-if="!data.is_municipal && !data.is_scheduled" class="form-group"
            :class="{ 'has-error': errors['mobile'] }">
            <label class="col-sm-2 control-label">¿Móvil?</label>
            <div class="col-sm-10">
                <div class="radio">
                    <label><input type="radio" v-model="data.mobile" :value="true" /> Si</label>
                    <label><input type="radio" v-model="data.mobile" :value="false" /> No</label>
                </div>
                <div class="help-block" v-for="e in errors['mobile']">{{ e }}</div>
            </div>
        </div>

        <div class="form-group" :class="{ 'has-error': errors['is_suspended'] }">
            <label class="col-sm-2 control-label">¿Atención suspendida?</label>
            <div class="col-sm-10">
                <div class="radio" :key="'suspended-' + data.is_suspended">
                    <label><input type="radio" v-model="data.is_suspended" :value="true" /> Si</label>
                    <label><input type="radio" v-model="data.is_suspended" :value="false" /> No</label>
                </div>
                <div class="help-block" v-for="e in errors['is_suspended']">{{ e }}</div>
            </div>
        </div>

        <div v-if="!data.mobile && !data.is_scheduled" class="form-group"
            :class="{ 'has-error': errors['is_municipal'] }">
            <label class="col-sm-2 control-label">¿Punto de atención Municipal?</label>
            <div class="col-sm-10">
                <div class="radio" :key="'municipal-' + data.is_municipal">
                    <label><input type="radio" v-model="data.is_municipal" :value="true" /> Si</label>
                    <label><input type="radio" v-model="data.is_municipal" :value="false" /> No</label>
                </div>
                <div class="help-block" v-for="e in errors['is_municipal']">{{ e }}</div>
            </div>
        </div>

        <div v-if="!data.mobile && !data.is_municipal" class="form-group"
            :class="{ 'has-error': errors['is_scheduled'] }">
            <label class="col-sm-2 control-label">¿Se puede agendar?</label>
            <div class="col-sm-10">
                <div class="radio">
                    <label><input type="radio" v-model="data.is_scheduled" :value="true" /> Si</label>
                    <label><input type="radio" v-model="data.is_scheduled" :value="false" /> No</label>
                </div>
                <div class="help-block" v-for="e in errors['is_scheduled']">{{ e }}</div>
            </div>
        </div>

        <div v-if="!data.mobile" class="form-group"
            :class="{ 'has-error': errors['has_mex'] }">
            <label class="col-sm-2 control-label">¿Tiene MEX?</label>
            <div class="col-sm-10">
                <div class="radio">
                    <label><input type="radio" v-model="data.has_mex" :value="true" /> Si</label>
                    <label><input type="radio" v-model="data.has_mex" :value="false" /> No</label>
                </div>
                <div class="help-block" v-for="e in errors['has_mex']">{{ e }}</div>
            </div>
        </div>
        
        

        <div v-if="data.mobile || data.is_municipal" class="form-group" :class="{ 'has-error': errors['schedules'] }">
            <label for="schedules" class="col-sm-2 control-label">Horario</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="schedules" v-model="data.schedules">
                <div class="help-block" v-for="e in errors['schedules']">{{ e }}</div>
            </div>
        </div>
        <div v-if="!data.mobile && !data.is_municipal" class="form-group"
            :class="{ 'has-error': errors['opening_hours'] }" id="opening-hours-section">
            <label for="opening_hours" class="col-sm-2 control-label">Horas de apertura</label>
            <div class="col-sm-10">
                <opening-hours v-model="data.opening_hours" @setHasEmptySchedule="hasEmptySchedule = $event"
                    @scheduleErrors="handleScheduleErrors">
                </opening-hours>
                <div class="help-block" v-if="errors['opening_hours']">
                    {{ errors['opening_hours'][0] }}
                </div>
            </div>
        </div>

        <div class="form-group" :class="{ 'has-error': errors['observations'] }">
            <label for="observations" class="col-sm-2 control-label">Observaciones generales</label>
            <div class="col-sm-10">
                <editor id="observations" v-model="data.observations">
                </editor>
                <small class="text-muted">{{ getTextLength(data.observations) }}/140 caracteres</small>
                <div class="help-block" v-for="e in errors['observations']">{{ e }}</div>
            </div>
        </div>

        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <a class="btn btn-default" href="backend/oficinas">Cancelar</a>
                <button type="submit" class="btn btn-primary">Guardar</button>
            </div>
        </div>
    </form>
</template>
<style lang="scss" scoped>
.el-select {
    display: block;
}

#map_marker {
    height: 280px;
}

.ubicacion {
    background: #F7F7F7;
    border: 1px solid #F7F7F7;
    border-radius: 4px;
    display: block;
    padding-top: 14px;
    margin-bottom: 7px;
}

.subtitle {
    color: #757575;
}

/* Asegurar que los labels no se vean afectados por has-error */
.form-group {
    &.has-error {
        .control-label.no-error {
            color: inherit !important;
        }
    }
}

/* Estilo específico para los inputs cuando hay error */
.has-error {

    .el-select,
    .el-time-select,
    .form-control {
        &:not(.no-error) {
            border-color: #a94442;
        }
    }
}
</style>
<script>
import OpeningHours from './OpeningHours.vue';
import Editor from "./Editor.vue";
import InstitutionSelect from './InstitutionSelect.vue';
import CitySelect from './CitySelect.vue';
import LocationSection from './office-form/LocationSection.vue';
import Vue from 'vue';

var url2 = baseUrl;
export default {
    props: {
        office: {
            type: Object,
            required: true,
        },
        edit: {
            type: Boolean,
            default: false
        }
    },
    data() {
        const initialData = {
            address: null,
            created_at: null,
            director: null,
            fax: null,
            id: null,
            institution_id: 'AL005',
            lat: null,
            lng: null,
            location_id: null,
            mobile: false,
            is_municipal: false,
            is_scheduled: false,
            name: null,
            phones: null,
            schedules: null,
            type: null,
            updated_at: null,
            opening_hours: [],
            location_observations: "",
            observations: "",
            map_type: null,
            map_url: null,
            is_suspended: false,
            status: 1,
            has_mex: false,
        };
        return {
            data: _.assign({}, initialData, this.office), // Fusiona los datos iniciales con los datos de office
            disabled: false,
            url: url2 + '/manual-backend/administracion_general/#213-oficinas',
            errors: {},
            hasEmptySchedule: false,
            scheduleErrors: null,
            isSubmitting: false,
            locationData: {
                map_type: this.office?.map_type || 'coordinates',
                location_id: this.office?.location_id || null,
                address: this.office?.address || null,
                lat: this.office?.lat || null,
                lng: this.office?.lng || null,
                map_url: this.office?.map_url || null,
                location_observations: this.office?.location_observations || ''
            },
        };
    },
    components: {
        InstitutionSelect,
        CitySelect,
        OpeningHours,
        Editor,
        LocationSection,
    },
    methods: {
        handleScheduleErrors: _.debounce(function (errors) {
            if (!errors) {
                Vue.set(this.errors, 'opening_hours', []);
                return;
            }

            let errorMessage = '';
            // Primero verificamos el error de tiempo inválido
            if (errors.invalidTimes) {
                errorMessage = 'La hora de cierre debe ser posterior a la hora de apertura.';
            } else if (errors.emptyDays) {
                errorMessage = 'Por favor, seleccione al menos un día para todos los horarios.';
            } else if (errors.emptyTimes) {
                errorMessage = 'Por favor, seleccione las horas de apertura y cierre.';
            }

            if (errorMessage !== this.errors?.opening_hours?.[0]) {
                Vue.set(this.errors, 'opening_hours', [errorMessage]);
            }
        }, 300),

        isInvalidTimeRange(opens, closes) {
            if (!opens || !closes) return true;

            const [openHour, openMinute] = opens.split(':').map(Number);
            const [closeHour, closeMinute] = closes.split(':').map(Number);

            const openingMinutes = openHour * 60 + openMinute;
            const closingMinutes = closeHour * 60 + closeMinute;

            return openingMinutes >= closingMinutes;
        },

        scrollToError(elementId) {
            this.$nextTick(() => {
                const element = document.getElementById(elementId);
                if (element) {
                    element.scrollIntoView({
                        behavior: "smooth",
                        block: "center"
                    });
                }
            });
        },
        async handleSubmit(event) {
            event.preventDefault();

            // Reset errores al inicio
            this.errors = {};

            try {
                // Prevenir múltiples submits
                if (this.isSubmitting) {
                    return false;
                }

                // Validar título
                if (!this.data.name?.trim()) {
                    Vue.set(this.errors, 'name', ['El título es obligatorio']);
                    this.scrollToError('name');
                    return false;
                }

                // Nueva validación del título
                const titleErrors = this.validateTitle(this.data.name);
                if (titleErrors.length > 0) {
                    Vue.set(this.errors, 'name', titleErrors);
                    this.scrollToError('name');
                    return false;
                }

                // Validar ubicación
                if (!this.$refs.locationSection.validate()) {
                    this.scrollToError('location-section');
                    return false;
                }

                // Verificar si usa horario simple (móvil o municipal)
                const needsSimpleSchedule = this.data.mobile || this.data.is_municipal;

                if (!this.data.is_suspended) {
                    if (!needsSimpleSchedule) {
                        // Validar que existan horarios
                        if (!this.data.opening_hours?.length) {
                            Vue.set(this.errors, 'opening_hours', ['Debe agregar al menos un horario.']);
                            this.scrollToError('opening-hours-section');
                            return false;
                        }

                        // Validar cada horario
                        const hasInvalidSchedule = this.data.opening_hours.some(schedule => {
                            return !schedule.dayOfWeek?.length ||
                                !schedule.opens ||
                                !schedule.closes ||
                                this.isInvalidTimeRange(schedule.opens, schedule.closes);
                        });

                        if (hasInvalidSchedule || this.hasEmptySchedule) {
                            Vue.set(this.errors, 'opening_hours', ['Por favor, complete correctamente todos los horarios.']);
                            this.scrollToError('opening-hours-section');
                            return false;
                        }
                    } else if (!this.data.schedules?.trim()) {
                        Vue.set(this.errors, 'schedules', ['El horario es obligatorio.']);
                        return false;
                    }
                }

                // Si llegamos aquí, las validaciones pasaron
                this.isSubmitting = true;

                const url = this.edit ? `backend/oficinas/${this.data.id}` : 'backend/oficinas';
                const method = this.edit ? 'PUT' : 'POST';

                const response = await axios({
                    url: url,
                    method: method,
                    data: this.data,
                });

                // Solo redirigir si la petición fue exitosa
                if (response.data?.redirect) {
                    window.location.replace(response.data.redirect);
                }

            } catch (error) {
                // Si es un error de axios
                if (error.response?.data?.errors) {
                    this.errors = error.response.data.errors;
                }
                // Si hay errores del servidor, scrollear al primer error
                if (error.response?.data?.errors) {
                    const firstErrorField = Object.keys(error.response.data.errors)[0];
                    const elementId = this.getElementIdForField(firstErrorField);
                    if (elementId) {
                        this.scrollToError(elementId);
                    }
                }

            } finally {
                this.isSubmitting = false;
            }

            return false;
        },

        getElementIdForField(fieldName) {
            // Mapeo de campos a IDs de elementos
            const fieldToElementMap = {
                'name': 'name',
                'location': 'location-section',
                'schedules': 'schedules',
                'opening_hours': 'opening-hours-section',
                'observations': 'observations'
                // Agregar más mappings según sea necesario
            };

            return fieldToElementMap[fieldName];
        },
        validateTitle(title) {
            // Validar caracteres consecutivos
            if (/--/.test(title)) {
                return ['No se permiten guiones consecutivos'];
            }
            if (/''/.test(title)) {
                return ['No se permiten comillas simples consecutivas'];
            }
            if (/""/.test(title)) {
                return ['No se permiten comillas dobles consecutivas'];
            }

            // Regex actualizada para permitir acentos y ñ
            const validCharactersRegex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9\s'"'-]+$/;
            if (!validCharactersRegex.test(title)) {
                return ['El título solo puede contener letras, números, acentos, guiones, comillas simples y comillas dobles'];
            }

            return [];
        },
        getTextLength(htmlString) {
            if (!htmlString || htmlString === '<p></p>') return 0;
            const editor = tinymce.get('observations');
            if (editor) {
                const text = editor.getContent({ format: 'text' }).trim();
                return text.length;
            }
            const temp = document.createElement('div');
            temp.innerHTML = htmlString;
            return (temp.textContent || temp.innerText).trim().length;
        },
    },
    watch: {
        office: {
            immediate: true,
            deep: true,
            handler(newOffice) {
                // Actualiza data cada vez que office cambia
                this.data = _.assign({}, this.data, newOffice);
            }
        },
        locationData: {
            deep: true,
            handler(newValue) {
                // Sincronizar los datos de ubicación con el componente principal
                Object.assign(this.data, newValue);
            }
        },
        'data.observations': {
            handler(newValue) {
                const editor = tinymce.get('observations');
                if (!editor) return;

                const setupEvents = () => {
                    editor.off('keydown keyup change');

                    const handleContent = () => {
                        const length = this.getTextLength(editor.getContent());
                        if (length > 140) {
                            const text = editor.getContent({ format: 'text' }).substring(0, 140);
                            editor.setContent(`<p>${text}</p>`);
                            this.data.observations = editor.getContent();
                        } else {
                            this.data.observations = editor.getContent();
                        }
                        this.$forceUpdate();
                    };

                    editor.on('keyup change', handleContent);
                };

                if (editor.initialized) {
                    setupEvents();
                } else {
                    editor.on('init', setupEvents);
                }
            },
            immediate: true
        },
        'data.name': {
            handler(newValue) {
                if (newValue?.trim()) {
                    const titleErrors = this.validateTitle(newValue);
                    if (titleErrors.length > 0) {
                        Vue.set(this.errors, 'name', titleErrors);
                    } else {
                        Vue.delete(this.errors, 'name');
                    }
                } else {
                    Vue.delete(this.errors, 'name');
                }
            },
            immediate: true
        }
    },
    beforeDestroy() {
        const editor = tinymce.get('observations');
        if (editor) {
            editor.off('keydown keyup change init');
        }
    },
};
</script>